module.exports = "<div class=\"home-page-container\">\n    <div class=\"home-page-container__main-wallpaper\"></div>\n    <div *ngIf=\"productsAreAvailable\">\n        <product-carousel [productList]=\"popularArray\">{{'HOME.POPULAR' | translate}}</product-carousel>\n        <product-carousel [productList]=\"recommendedArray\">{{'HOME.RECOMMENDED' | translate}}</product-carousel>\n    </div>\n    <product-popup></product-popup>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/pages/home/home.component.html
// module id = ../../../../../src/app/pages/home/home.component.html
// module chunks = main